import React from 'react';
import { Interest } from '@springbig/shared';
import { Box, HStack } from 'native-base';
import ItemCard, { ItemCardSkeleton } from '~/shared/ItemCard';
import { H2 } from '~/shared/Typography';
import { Panel } from '~/shared/Theme';

type ProfileInterestProps = {
    interest?: Interest[];
    handleInterest: (name?: string) => void;
    updateIsLoading: boolean;
}

const ProfileInterest = ({ interest, handleInterest, updateIsLoading }: ProfileInterestProps) => {

    return (
        <Panel space={4}>
            <H2 text={'interests.title'} />
            { !interest || interest.length < 1 ?
                <HStack justifyContent={'space-around'}>
                    <ItemCardSkeleton />
                    <ItemCardSkeleton />
                </HStack>
                :
                <Box // somehow HStack is problematic here | try with > 4 interests to see the effect
                    display={'flex'}
                    flexDirection={'row'}
                    flexWrap={'wrap'}
                    justifyContent={'center'}
                    gap={4}
                >
                    { interest && interest.map(data => {

                        return (
                            <Box key={data.id} w={48}>
                                <ItemCard
                                    customImageWidth={48}
                                    customImageWidthPx={'192px'}
                                    loadingComponent={true}
                                    boxProps={{ w: '100%' }}
                                    needsMark={true}
                                    handleCallback={(id, title, selectedInterest) => handleInterest(selectedInterest)}
                                    isDisabled={updateIsLoading}
                                    checked={data.checked}
                                    id={data.id}
                                    interest={data.name}
                                    title={data.display_name || data.name}
                                    imageUrl={data.image_url || undefined}
                                />
                            </Box>
                        );
                    })}
                </Box>
            }
        </Panel>
    );

};


export default ProfileInterest;
